import React from "react";
import logoIcon from "../../../img/LOGO-128.png";
import Carousel from "react-bootstrap/Carousel";

const CarouselSec = () => {
  return (
    <Carousel
      className="homeCarousel statusCarousel"
      nextIcon={null}
      prevIcon={null}
      indicators={true}
    >
      <Carousel.Item interval={2000}>
        <h4>100 Order Placed</h4>
        <p>in last 24 hours</p>
        <div className="d-flex align-items-center justify-content-center">
          <img className="d-block me-1" width={24} src={logoIcon} alt="First slide" />
          Rashan Point
        </div>
      </Carousel.Item>
      <Carousel.Item interval={2000}>
      <h4>5000+ Items Sold</h4>
        <p>in last 7 days</p>
        <div className="d-flex align-items-center justify-content-center">
          <img className="d-block me-1" width={24} src={logoIcon} alt="First slide" />
          Rashan Point
        </div>
      </Carousel.Item>
      <Carousel.Item interval={2000}>
        <h4>₹625 Savings</h4>
        <p>has been done by you</p>
        <div className="d-flex align-items-center justify-content-center">
          <img className="d-block me-1" width={24} src={logoIcon} alt="First slide" />
          Rashan Point
        </div>
      </Carousel.Item>
    </Carousel>
  );
};
export default React.memo(CarouselSec);
